import BaseApi from "../base";

export default class Activities extends BaseApi {

}

